export default {"src":"/_next/static/media/clock.45cd1787.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};